module.exports = __webpack_public_path__ + "img/img4.d6324a44.png";